export default __webpack_public_path__ + "static/media/searchIcon.51b83338.svg";